export const authTranslations = {
  en: {
    signIn: 'Sign in',
    signInTitle: 'Welcome back',
    signInHelper: 'Sign in to continue to your GFI International Trainer Hub.',
    password: 'Password',
    createPassword: 'Create password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    forgotPasswordToast: 'Password reset is a visual demo only. Please contact your recruiter for support.',
    noInvitation: "Don't have an invitation?",
    contactRecruiter: 'Contact your recruiter',
    invitationLink: 'Have an invitation link?',
    acceptInvitation: 'Accept invitation',
    invitationEyebrow: 'GFI INTERNATIONAL',
    invitedBy: "You've been invited by",
    invitedTo: 'to GFI International Trainer Hub.',
    accountHelper: 'Set up your profile to begin learning and connecting with your team.',
    fullName: 'Full name',
    preferredLanguage: 'Preferred language',
    country: 'Country',
    createAccount: 'Create account',
    creatingAccount: 'Creating your account...',
    welcomeTitle: 'Welcome to GFI International Trainer Hub',
    welcomeHelper: 'Your account is ready. Taking you to your learning space...',
    requiredField: 'This field is required.',
    passwordLength: 'Use at least 6 characters.',
    passwordMatch: 'Passwords do not match.',
    invalidEmail: 'Enter a valid email address.',
    demoMode: 'Demo mode',
    demoModeHelper: 'For internal QA only. Preview the platform from any role.',
    demoDivider: 'or use a testing shortcut',
    invitationUnavailable: 'This invitation is no longer available.',
    signInSuccess: 'Signed in successfully.',
    countries: {
      Argentina: 'Argentina',
      Bolivia: 'Bolivia',
      Brazil: 'Brazil',
      Chile: 'Chile',
      Colombia: 'Colombia',
      CostaRica: 'Costa Rica',
      DominicanRepublic: 'Dominican Republic',
      Ecuador: 'Ecuador',
      ElSalvador: 'El Salvador',
      Guatemala: 'Guatemala',
      Honduras: 'Honduras',
      Mexico: 'Mexico',
      Nicaragua: 'Nicaragua',
      Panama: 'Panama',
      Paraguay: 'Paraguay',
      Peru: 'Peru',
      PuertoRico: 'Puerto Rico',
      Uruguay: 'Uruguay',
      UnitedStates: 'United States',
      Venezuela: 'Venezuela'
    }
  },
  es: {
    signIn: 'Iniciar sesión',
    signInTitle: 'Te damos la bienvenida',
    signInHelper: 'Inicia sesión para continuar al Centro de Capacitación GFI International.',
    password: 'Contraseña',
    createPassword: 'Crear contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    forgotPasswordToast: 'El restablecimiento de contraseña es solo una demostración visual. Contacta a tu reclutador para recibir ayuda.',
    noInvitation: '¿No tienes una invitación?',
    contactRecruiter: 'Contacta a tu reclutador',
    invitationLink: '¿Tienes un enlace de invitación?',
    acceptInvitation: 'Aceptar invitación',
    invitationEyebrow: 'GFI INTERNATIONAL',
    invitedBy: 'Has sido invitado por',
    invitedTo: 'al Centro de Capacitación GFI International.',
    accountHelper: 'Configura tu perfil para comenzar a aprender y conectar con tu equipo.',
    fullName: 'Nombre completo',
    preferredLanguage: 'Idioma preferido',
    country: 'País',
    createAccount: 'Crear cuenta',
    creatingAccount: 'Creando tu cuenta...',
    welcomeTitle: 'Bienvenido al Centro de Capacitación GFI International',
    welcomeHelper: 'Tu cuenta está lista. Te llevamos a tu espacio de aprendizaje...',
    requiredField: 'Este campo es obligatorio.',
    passwordLength: 'Usa al menos 6 caracteres.',
    passwordMatch: 'Las contraseñas no coinciden.',
    invalidEmail: 'Ingresa un correo electrónico válido.',
    demoMode: 'Modo de demostración',
    demoModeHelper: 'Solo para QA interno. Explora la plataforma desde cualquier rol.',
    demoDivider: 'o usa un acceso de prueba',
    invitationUnavailable: 'Esta invitación ya no está disponible.',
    signInSuccess: 'Sesión iniciada correctamente.',
    countries: {
      Argentina: 'Argentina',
      Bolivia: 'Bolivia',
      Brazil: 'Brasil',
      Chile: 'Chile',
      Colombia: 'Colombia',
      CostaRica: 'Costa Rica',
      DominicanRepublic: 'República Dominicana',
      Ecuador: 'Ecuador',
      ElSalvador: 'El Salvador',
      Guatemala: 'Guatemala',
      Honduras: 'Honduras',
      Mexico: 'México',
      Nicaragua: 'Nicaragua',
      Panama: 'Panamá',
      Paraguay: 'Paraguay',
      Peru: 'Perú',
      PuertoRico: 'Puerto Rico',
      Uruguay: 'Uruguay',
      UnitedStates: 'Estados Unidos',
      Venezuela: 'Venezuela'
    }
  }
};

export const countryOptions = [
  'Argentina',
  'Bolivia',
  'Brazil',
  'Chile',
  'Colombia',
  'CostaRica',
  'DominicanRepublic',
  'Ecuador',
  'ElSalvador',
  'Guatemala',
  'Honduras',
  'Mexico',
  'Nicaragua',
  'Panama',
  'Paraguay',
  'Peru',
  'PuertoRico',
  'Uruguay',
  'UnitedStates',
  'Venezuela'
];